import React from 'react';
import { Overlay } from './Overlay';
import { BriefSectionView } from './BriefSectionView';
import { ConceptUsage } from './ConceptUsage';
import { briefClosing, briefSections, briefSubtitle } from '../../data/brief';
import type { Format } from '../../types/snak';
interface ConceptOverlayProps {
  format: Format;
  onFormatChange: (format: Format) => void;
  onClose: () => void;
}
export function ConceptOverlay({
  format,
  onFormatChange,
  onClose
}: ConceptOverlayProps) {
  const compact = format === 'mobile';
  return <Overlay eyebrow="Concept & strategy" format={format} onFormatChange={onFormatChange} onClose={onClose} data-id="element-123" data-mp="2k0ads1tmcxix">
      <div className={compact ? 'px-6 pb-14 pt-10' : 'mx-auto max-w-[720px] px-6 pb-20 pt-14 lg:px-0 lg:pt-20'} data-id="element-124" data-mp="2622moaj9kqfo">
        <h1 className={['font-heading leading-[0.96] tracking-[-0.03em] text-background', compact ? 'text-[34px]' : 'text-[46px] sm:text-[56px]'].join(' ')} data-id="element-125" data-mp="494nlwyw91ma">
          Meet the Filtek’s
        </h1>
        <p className={['max-w-[28ch] font-heading leading-[1.25] tracking-[-0.01em] text-[rgba(1,51,43,0.6)]', compact ? 'mt-4 text-[16px]' : 'mt-5 text-[21px]'].join(' ')} data-id="element-126" data-mp="1h0tc02jh7bzr">
          {briefSubtitle}
        </p>

        <div className={compact ? 'mt-12 space-y-12' : 'mt-20 space-y-16'} data-id="element-127" data-mp="1puxy68nnzz8y">
          {briefSections.map((section, i) => <BriefSectionView key={section.id} section={section} index={i} compact={compact} data-id="element-128" data-mp="y1xfulo24nja" data-mpi={i} />)}
        </div>

        <section className={['border-t border-[rgba(1,51,43,0.14)]', compact ? 'mt-12 pt-8' : 'mt-16 pt-10'].join(' ')} data-id="element-129" data-mp="172dgzohbvikz">
          <p className={['max-w-[24ch] font-heading leading-[1.06] tracking-[-0.02em] text-background', compact ? 'text-[25px]' : 'text-[34px]'].join(' ')} data-id="element-130" data-mp="2ni6nyfup7ugr">
            {briefClosing.statement}
          </p>
          <p className={['mt-4 font-heading leading-tight text-[rgba(1,51,43,0.55)]', compact ? 'text-[17px]' : 'text-[22px]'].join(' ')} data-id="element-131" data-mp="2uhz6q44kwfld">
            {briefClosing.support}
          </p>
        </section>

        <footer className={['border-t border-[rgba(1,51,43,0.12)]', compact ? 'mt-12 pt-6' : 'mt-16 pt-8'].join(' ')} data-id="element-132" data-mp="26v0qn7kdf9nz">
          <p className="font-body text-[12px] leading-relaxed text-[rgba(1,51,43,0.55)]" data-id="element-133" data-mp="2gsf3kx735gbj">
            Original concept &amp; creative direction by Snakker™
          </p>
          <ConceptUsage data-id="element-134" data-mp="2lkygdrxy87fa" />
        </footer>
      </div>
    </Overlay>;
}